import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import {
  getAccountExpenses,
  getAccountExpense,
  createAccountExpense,
  updateAccountExpense,
  deleteAccountExpense,
  approveAccountExpense,
  rejectAccountExpense,
} from "api/accountExpenseApi"

export const ACCOUNT_EXPENSE_QUERY_KEY = "account-expenses"

export const useAccountExpenses = (params = {}, enabled = true) => {
  return usePaginatedResource(
    ACCOUNT_EXPENSE_QUERY_KEY,
    getAccountExpenses,
    params,
    enabled
  )
}

export const useAccountExpense = (id, enabled = true) => {
  return useResourceItem(ACCOUNT_EXPENSE_QUERY_KEY, getAccountExpense, id, enabled)
}

export const useCreateAccountExpense = () => {
  return useCreateResource(createAccountExpense, ACCOUNT_EXPENSE_QUERY_KEY)
}

export const useEditAccountExpense = () => {
  return useEditResource(updateAccountExpense, ACCOUNT_EXPENSE_QUERY_KEY)
}

export const useDeleteAccountExpense = () => {
  return useDeleteResource(deleteAccountExpense, ACCOUNT_EXPENSE_QUERY_KEY)
}

export const useApproveAccountExpense = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: approveAccountExpense,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [ACCOUNT_EXPENSE_QUERY_KEY] }),
  })
}

export const useRejectAccountExpense = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: rejectAccountExpense,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [ACCOUNT_EXPENSE_QUERY_KEY] }),
  })
}
